import { makeCompositeId } from '@cbridge-utils/formatters';
import { IClientLp } from '@cbridge-packages/lp-client';
import { ISymbolLp } from '../symbolLp.interface';

export const makeLpSymbolCompositeId = (lpId: IClientLp['lpId'], name: ISymbolLp['name']) => makeCompositeId([lpId, name]);
